const ENERGY_DIAG_PREFIX = "[EnergyDiag]";
const ENERGY_DIAG_BUFFER_KEY = "__ENERGY_DIAG_LOGS__";
const DISABLE_DIAG_KEY = "tlatfarm:disableEnergyDiag";

const isTruthyFlag = (value) => value === "1" || value === "true";

const isEnergyDiagDisabled = () => {
  if (typeof window === "undefined") return false;
  try {
    const fromStorage = window.localStorage.getItem(DISABLE_DIAG_KEY);
    if (isTruthyFlag(fromStorage)) return true;

    const queryValue = new URLSearchParams(window.location.search).get(
      "energyDiag"
    );
    return queryValue === "0" || queryValue === "false";
  } catch {
    return false;
  }
};

const getErrorMeta = (error) => ({
  status: error?.response?.status ?? null,
  code: error?.code ?? null,
  message: error?.message ?? "Unknown error",
  method: error?.config?.method ?? null,
  url: error?.config?.url ?? null,
  responseData: error?.response?.data ?? null,
});

const pushEnergyDiagBuffer = (entry) => {
  if (typeof window === "undefined") return;
  if (!Array.isArray(window[ENERGY_DIAG_BUFFER_KEY])) {
    window[ENERGY_DIAG_BUFFER_KEY] = [];
  }
  const buffer = window[ENERGY_DIAG_BUFFER_KEY];
  buffer.push(entry);
  if (buffer.length > 200) buffer.shift();
};

const emitEnergyDiagnostic = (level, event, details = {}) => {
  if (isEnergyDiagDisabled()) return;

  const payload = {
    timestamp: new Date().toISOString(),
    ...details,
  };

  pushEnergyDiagBuffer({ level, event, ...payload });

  if (level === "error") {
    console.error(`${ENERGY_DIAG_PREFIX} ${event}`, payload);
    return;
  }

  console.warn(`${ENERGY_DIAG_PREFIX} ${event}`, payload);
};

export const logEnergyDiagnostic = (event, details = {}) => {
  emitEnergyDiagnostic("warn", event, details);
};

export const logEnergyDiagnosticError = (event, error, details = {}) => {
  emitEnergyDiagnostic("error", event, {
    ...details,
    ...getErrorMeta(error),
  });
};
